// ── Light palette (app interior) ──────────────────────────────────────────
export const C = {
  bg:"#F2EDE4",panel:"#EAE4D9",border:"#C8BFA8",
  textMid:"#3D3425",textDim:"#7A6E5E",textFaint:"#A89880",
  ink:"#0F0C08",white:"#FDFAF6",
  red:"#8B1A1A",redBg:"#F5E8E8",
  blue:"#1A3A5C",blueBg:"#E8EEF5",
  green:"#1A4A2A",greenBg:"#E8F0EA",
  gold:"#7A5C28",goldBg:"#F5F0E0",
  purple:"#3A1A5C",purpleBg:"#EEE8F5",
  teal:"#1A4A4A",tealBg:"#E8F5F0",
};

// ── Dark palette (landing page) ────────────────────────────────────────────
export const D = {
  bg:"#080705",surface:"#0F0D0A",card:"#141210",
  border:"#1C1A16",borderMid:"#2C2820",
  text:"#EDE8DF",textDim:"#787060",textFaint:"#383020",
  gold:"#C8A044",
};

// ── Domain data ────────────────────────────────────────────────────────────
// TODOS los temperamentos que el generador de casos puede asignar
export const PERSONAS = {
  hostil:      { label:"Hostil",        color:"#8B1A1A", desc:"Evasivo, defensivo, mínimo detalle" },
  cooperativo: { label:"Cooperativo",   color:"#1A4A2A", desc:"Claro pero no voluntario" },
  nervioso:    { label:"Nervioso",      color:"#7A5C00", desc:"Se contradice, duda, cambia detalles" },
  evasivo:     { label:"Evasivo",       color:"#4A2A6A", desc:"Responde con preguntas, evita comprometerse" },
  tecnico:     { label:"Técnico",       color:"#1A3A5C", desc:"Metódico, preciso, habla con datos" },
  dramatico:   { label:"Dramático",     color:"#6A1A4A", desc:"Expresivo, emocional, enfático" },
  seguro:      { label:"Seguro",        color:"#1A4A4A", desc:"Firme, sin titubeos, no cambia su versión" },
  desconfiado: { label:"Desconfiado",   color:"#4A3A1A", desc:"Cauteloso, pregunta antes de responder" },
};

export const WITNESS_TYPES = {
  testigo: { label:"Testigo presencial", icon:"👁" },
  perito:  { label:"Perito técnico",     icon:"🔬" },
  experto: { label:"Experto forense",    icon:"🧬" },
  policia: { label:"Agente de Policía",  icon:"👮" },
};

export const CRIMES = {
  lesiones: { key:"lesiones", label:"Lesiones", article:"Art. 152 COIP", desc:"Lesiones dolosas causadas a una persona" },
  robo:     { key:"robo",     label:"Robo",     article:"Art. 189 COIP", desc:"Apoderamiento de bien ajeno con violencia o amenaza" },
};

export const OBJECTION_TYPES = [
  { key:"sugestiva",     label:"Sugestiva",     desc:"La pregunta sugiere la respuesta — Art. 563 COIP" },
  { key:"compuesta",     label:"Compuesta",     desc:"Dos preguntas en una sola — Art. 563 COIP" },
  { key:"capciosa",      label:"Capciosa",      desc:"Formulada para confundir al testigo — Art. 563 COIP" },
  { key:"especulacion",  label:"Especulación",  desc:"Pide opinar sobre lo que no sabe — Art. 563 COIP" },
  { key:"irrelevante",   label:"Irrelevante",   desc:"No guarda relación con el caso — Art. 563 COIP" },
  { key:"argumentativa", label:"Argumentativa", desc:"Argumento disfrazado de pregunta — Art. 563 COIP" },
  { key:"repetitiva",    label:"Repetitiva",    desc:"La pregunta ya fue formulada y respondida — Art. 563 COIP" },
];

export const TIPS = {
  interrogatorio: [
    "Usa preguntas abiertas: ¿Qué vio? ¿Dónde estaba? ¿Qué ocurrió después?",
    "Construye credibilidad antes de llegar al punto central del testimonio.",
    "El testigo propio debe contar la historia — tú solo guías con preguntas abiertas.",
  ],
  contrainterrogatorio: [
    "En el contrainterrogatorio puedes usar preguntas sugestivas — es la única fase donde están permitidas.",
    "Preguntas cortas y cerradas. El testigo solo puede responder sí o no.",
    "Termina en punto alto. La última pregunta debe ser tu mejor argumento.",
    "Nunca hagas una pregunta cuya respuesta no conoces de antemano.",
  ],
};

export const TUTORIAL_STEPS = [
  { icon:"⚖", title:"La Sala de Audiencias",     text:"La Secretaria abrirá el juicio formalmente. El Juez dará las instrucciones. Escucha antes de intervenir." },
  { icon:"👁", title:"El panel del testigo",      text:"A tu izquierda verás el perfil del testigo en estrado, las teorías del caso y los informes descargables." },
  { icon:"🎤", title:"Tu turno de interrogar",    text:"Escribe tu pregunta y presiona Enter. En el interrogatorio directo, solo preguntas abiertas." },
  { icon:"🔨", title:"Las objeciones",            text:"Usa el botón 🔨 para objetar una pregunta irregular del adversario. El Juez fallará citando el COIP." },
  { icon:"✋", title:"Flujo completo de testigos", text:"Todos los testigos participan. Cuando termines con uno, el Juez llamará al siguiente. Presiona 'Terminar interrogatorio' cuando hayas agotado tus preguntas." },
];
